import React from 'react'

const FormLabel = (props) => {
  return (
    <label className={`form-label`}>{props.label} {props.required ? <span>*</span> : ''}</label>
  )
}

export default FormLabel


// WEBPACK FOOTER //
// ./src/ui/FormLabel.js